import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  dialog: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '100%',
  },
  select: {
    width: 100,
  },
  iconButton: {
    padding: 0,
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.grey[300]} `,
    width: '100%',
    fontSize: '20px',
  },
  defaultSelect: {
    color: theme.palette.grey[700],
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  overFlowEllipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  progress: {
    width: 'inherit',
  },
  partNumber: {
    maxWidth: '100px',
  },
  tableContainer: {
    height: '320px',
  },
}));

export default useStyles;
